import PiPopupWindowPreview from "../components/PiPopupWindowPreview";
import SlideshowBodyPreview from "./SlideshowBodyPreview";
import PiPopupHeaderBar from "../components/PiPopupHeaderBar";
import { InteractionType } from "../../../models/interactions/Interaction";

export default function SlideshowPreview() {
  return <PiPopupWindowPreview body={<SlideshowBodyPreview />} header={<PiPopupHeaderBar interactionType={InteractionType.Slideshow} title="Slideshow Quiz" />} />;
}
